import { getCssSizeValue, getHtmlFromRedactorField, getMarginsData, isStringEmpty } from "@/utils/utils"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import React from "react"
import styled from "styled-components"
import { useStructuredContext } from "@/components/common/StructuredText"
import { BREAKPOINTS } from "@/styles/themeSettings"
import DynamicMargin from "@/components/common/DynamicMargin"

const MARGIN_SIZES = {
	TOP: {
		MOBILE: 48,
		TABLET: 48,
		DESKTOP: 48,
	},
	BOTTOM: {
		MOBILE: 48,
		TABLET: 40,
		DESKTOP: 48,
	},
}

const StyledColouredBackground = styled.div`
	background: ${({ theme, $bgColor }) => ($bgColor ? theme.colors[$bgColor] : theme.colors.periwinkle)};
	padding-top: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	padding-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-top: ${getCssSizeValue(48)};
		padding-bottom: ${getCssSizeValue(48)};
	}

	.first {
		margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(16)};
		}
	}
`

export default function HighlightHeadingAndDescription({ data }) {
	const indent = useStructuredContext("indent")
	const width = useStructuredContext("width")

	const header = data?.header || ""
	const description = data?.description || ""
	const bgColor = data?.backgroundColor?.color || null
	const { marginTop, marginBottom } = getMarginsData(data)

	return (
		<DynamicMargin marginTop={marginTop} marginBottom={marginBottom} marginSizes={MARGIN_SIZES}>
			<StyledColouredBackground $bgColor={bgColor}>
				{!isStringEmpty(header) && (
					<GridContainer className={`first indent-desktop-${indent}`}>
						<Text
							className={`typo-borna typo-borna-26 col-mobile-8 col-tablet-8 col-desktop-${width}`}
							as="div"
							dangerouslySetInnerHTML={getHtmlFromRedactorField(header)}
						/>
					</GridContainer>
				)}
				{!isStringEmpty(description) && (
					<GridContainer className={`indent-desktop-${indent}`}>
						<Text
							className={`typo-strawford typo-strawford-25 col-mobile-8 col-tablet-8 col-desktop-${width}`}
							as="div"
							dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}
						/>
					</GridContainer>
				)}
			</StyledColouredBackground>
		</DynamicMargin>
	)
}
